
window.ULinkPullEntity = class ULinkPullEntity{
  redirectPath = ""
  id = 0
  constructor(redirectPath, id){
    this.redirectPath = redirectPath
    this.id = id
  }
}